module.exports = __webpack_public_path__ + "static/static.event/img/app-qrcode.500cce17.png";